import * as tslib_1 from "tslib";
import { AppStateFacade } from '@app-state';
import { FolderTreeStateService, } from '@components/ui-folder-tree/ui-folder-tree-state';
import { FolderType, } from '@models';
import { TranslateService } from '@ngx-translate/core';
import { FoldersService, ModalService, } from '@services';
import omit from 'lodash-es/omit';
import { of, } from 'rxjs';
import { filter, map, switchMap, tap, } from 'rxjs/operators';
import { UpsertFolderModalComponent } from './modals/upsert-folder/upsert-folder.modal';
var MAX_FOLDER_DEPTH = 7;
var FolderManagementService = /** @class */ (function (_super) {
    tslib_1.__extends(FolderManagementService, _super);
    function FolderManagementService() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.hasSwitchCapability = false;
        _this._endpoint = 'odata/Folders';
        _this.getFolders = function (expandedIds, take, skip) {
            return _this._http.get(_this._endpoint +
                ("/UiPath.Server.Configuration.OData.GetFoldersPage(skip=" + skip + ",take=" + take + ",expandedParentIds=[" + expandedIds + "])")).pipe(map(_this._mapData));
        };
        _this.searchFolders = function (skip, take, searchText) {
            if (!searchText) {
                return of({
                    total: 0,
                    data: [],
                });
            }
            var queryOptions = {
                skip: skip,
                top: take,
                filter: {
                    'DisplayName': {
                        contains: searchText,
                    },
                },
            };
            return _this.get(queryOptions);
        };
        return _this;
    }
    return FolderManagementService;
}(FoldersService));
export { FolderManagementService };
var FoldersPageComponent = /** @class */ (function () {
    function FoldersPageComponent(_appState, folderTreeState, _foldersService, _modal, _translateService) {
        var _this = this;
        this._appState = _appState;
        this.folderTreeState = folderTreeState;
        this._foldersService = _foldersService;
        this._modal = _modal;
        this._translateService = _translateService;
        this.MaxFolderDepth = MAX_FOLDER_DEPTH;
        this.FolderType = FolderType;
        this.currentHighlight$ = this.folderTreeState.highlighted$
            .pipe(filter(function (f) { return !!f; }), map(function (f) { return f.id; }));
        this.folderPermission = function () {
            var types = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                types[_i] = arguments[_i];
            }
            return types.map(function (t) { return "Units." + t + "|SubFolders." + t; }).join('|');
        };
        this.canViewUsersGrid$ = this.currentHighlight$.pipe(switchMap(function (folder) { return _this._appState.user
            .folderPermissions.isGranted(folder, 'SubFolders.View & Users.View | Units.View & Users.View'); }));
    }
    FoldersPageComponent.prototype.openEditFolderModal = function (folder) {
        var _this = this;
        this._modal
            .openModal(UpsertFolderModalComponent, {
            current: folder,
        })
            .afterClosedResult()
            .pipe(tap(function (result) {
            if (result.type === 5 /* Failed */) {
                throw result.additionalData;
            }
        }), filter(function (result) {
            return result.type === 2 /* Update */ &&
                !!_this.folderTreeState.highlighted$.value;
        }), switchMap(function (result) { return _this._foldersService.getInstance(result.data.current.id); }))
            .subscribe(function (updatedFolder) {
            _this.folderTreeState.patchFolder(omit(updatedFolder, ['isSelectable', 'level', 'hasChildren']));
        }, function () { return _this._refreshFolders(); });
    };
    FoldersPageComponent.prototype.openCreateFolderModal = function (parent) {
        var _this = this;
        this._modal
            .openModal(UpsertFolderModalComponent, {
            parent: parent || null,
        })
            .afterClosedResult()
            .subscribe(function () {
            if (parent && !_this.folderTreeState.isExpanded(parent.id)) {
                _this.folderTreeState.toggleExpand(parent, _this.folderTreeState.folderIndexById(parent.id));
            }
            _this._refreshFolders();
        });
    };
    FoldersPageComponent.prototype.removeFolder = function (folder) {
        var _this = this;
        this._modal
            .onConfirm(null, function () {
            return _this._foldersService.delete(folder.id)
                .subscribe(function () {
                _this._refreshFolders();
            });
        }, function () { }, this._translateService.instant('folders_page_are_you_sure_remove'));
    };
    FoldersPageComponent.prototype._refreshFolders = function () {
        this.folderTreeState.refresh();
    };
    return FoldersPageComponent;
}());
export { FoldersPageComponent };
